<template>
  <div class="cropper">
    <div class="top">
        <div id="trail">
            <ul>
                <li><a href="https://www.brighton.com/">Home</a></li>
                <li><a href="https://www.brighton.com/powerofpink/">Power Of Pink</a></li>
                <!-- <li><a href="../brighton-cares">The Butterfly Ribbon</a></li> -->
                <li><router-link to="/submit">Post your dedication</router-link></li>
                <li><router-link to="/submit">Edit</router-link></li>
            </ul>
        </div>
        <div class="staticPopTextWrapper">
            <span class="popButterflyTopLargeText">POWER</span>
            <span class="popButterflyTopSmallText">of</span><span class="popButterflyTopLargeText">&nbsp;PINK</span><br />
            <span class="popButterflyTopYears">17 Years of Giving</span><br />
            <span class="popButterflyTopRecognition">In recognition of Breast Cancer Awareness Month we would like to remember and honor members of our extended Brighton family</span>
        </div>
    </div>
    <!-- <h1>Crop image</h1> -->
    <div class="left">
      <div class="imageContainer" :class="{grayscale: grayscale}"><img id="imageToCrop" :src="$store.state.imageSrcDataURL" alt=""><img id="imageMask" :src="$store.state.maskImage" alt="">
      </div>
    </div>
    <div class="middle">
      <!-- <span class="step">
        <div>
          <span>STEP</span>
          <span class="num">1</span>
        </div>
      </span>
      <span class="step">
        <div>
          <span>STEP</span>
          <span class="num">2</span>
        </div>
      </span> -->
    </div>
    <div class="right">
      <span class="title">SIZE &AMP; SET YOUR PHOTO</span>
      <div class="controls">
        <!-- <input type="range"  v-model="zoom" min="1" max="200" class="slider" id="myRange"> -->
        <div class="row">
          <span class="label">SCALE IMAGE:</span>
          <input type="range"  v-model="zoom" min="1" max="100" class="slider" id="myRange">
        </div>
        <div class="row">
          <span class="label">ROTATE IMAGE:</span>
          <input type="range"  v-model="rotateDegree" min="0" max="360" class="slider" >
        </div>
        <div class="row">
          <span class="label">CONVERT COLOR:</span>
          <span @click="grayscale = !grayscale"><u>BLACK AND WHITE</u></span> | <span @click="reset"><u>RESET</u></span>
        </div>
        <div class="buttons">
          <button class="save" @click="getCroppedImage()">SAVE</button>
          <button class="startOver"  @click="$router.push({ path: 'submit' })">START OVER</button>
          <button class="differentImg" ><input type='file' @change="prepareFile($event.target.files)"/>CHOOSE A DIFFERENT IMAGE</button>
        </div>
      </div>
      <button class="cancel" @click="$router.push({ path: 'submit' })">CANCEL</button>
    </div>
  </div>
</template>





<script>

  import Cropper from 'cropperjs';
  import 'cropperjs/dist/cropper.min.css'
  import 'cropperjs/dist/cropper.min.js'


  const axios = require('axios');
  export default {
    name: 'edit',
    props: {
        // printoutPdfFileName: null,
        // confirmationNum: null,
        // downloadFileName: null,
        // addToCartLink: String,
        // storeType: Number,
        // selectedAmulets: Array
    },
    data() {
        return {
          cropper: '',
          zoom: 50,
          initialZoom: 50,
          rotateDegree: 0,
          grayscale: false,
          error:'',
          loading: false
        }
    },
    watch: {
      rotateDegree(newValue) {
        this.cropper.rotateTo(newValue)
      },
      zoom (newValue){
        this.cropper.zoomTo(newValue / 100)
      }
    },
    mounted () {
      console.log('mounted')
      if(this.$store.state.imageSrcDataURL == ''){
        this.$router.push({ path: 'submit' })
        console.log('redirecting')
        return false
      }
      // let that = this
      // const image = document.getElementById('imageToCrop');
      // this.cropper = new Cropper(image, {
      //     aspectRatio: 271 / 225,
      //     minCropBoxWidth: 271,
      //     minCropBoxHeight: 225,
      //     cropBoxResizable: false,
      //     cropBoxMovable: false,
      //     dragMode:'move',
      //     crop(event) {}
      // })
      // image.addEventListener('ready', ()=>{
      //   // if the aspect ratio is larger or equal to the mask's aspect ratio. the top/bottom is going to be cropped off 
      //   if(that.cropper.getImageData().aspectRatio >= 1.21 )
      //     that.zoom = parseInt(that.cropper.getImageData().width / that.cropper.getImageData().naturalWidth * 100)
      //   else
      //     that.zoom = parseInt(that.cropper.getImageData().height / that.cropper.getImageData().naturalHeight * 100)
      //   that.initialZoom = that.zoom
      // })
      this.initialize()
    },
    computed: {},
    methods:{
      initialize() {
        let that = this
        const image = document.getElementById('imageToCrop');
        this.cropper = new Cropper(image, {
            aspectRatio: 271 / 225,
            minCropBoxWidth: 271,
            minCropBoxHeight: 225,
            cropBoxResizable: false,
            cropBoxMovable: false,
            dragMode:'move',
            crop(event) {}
        })
        image.addEventListener('ready', ()=>{
          // if the aspect ratio is larger or equal to the mask's aspect ratio. the top/bottom is going to be cropped off 
          if(that.cropper.getImageData().aspectRatio >= 1.21 )
            that.zoom = parseInt(that.cropper.getImageData().width / that.cropper.getImageData().naturalWidth * 100)
          else
            that.zoom = parseInt(that.cropper.getImageData().height / that.cropper.getImageData().naturalHeight * 100)
          that.initialZoom = that.zoom
        })
      },
      reset() {
        this.rotateDegree = 0
        this.grayscale = false
        this.zoom = this.initialZoom
      },
      getCroppedImage(){
        let croppedImgCanvas = this.cropper.getCroppedCanvas({
          width: 271,
          height: 225,
          minWidth: 271,
          minHeight: 225,
          // maxWidth: 271,
          // maxHeight: 225,
          fillColor: '#dc568f',
          imageSmoothingEnabled: false,
          imageSmoothingQuality: 'high',
        })
        
        var newCtx = croppedImgCanvas.getContext('2d') ; 
        newCtx.save      () ; 

        var maskImage = new Image();
        maskImage.onload =  ()=>{
          // grayscale image ...before putting on the heart mask
          if(this.grayscale)
          {
            var imageData = newCtx.getImageData(0, 0, maskImage.width, maskImage.height);
            var data = imageData.data;
            for(var i = 0; i < data.length; i += 4) {
              var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
              // red
              data[i] = brightness;
              // green
              data[i + 1] = brightness;
              // blue
              data[i + 2] = brightness;
            }
            // overwrite original image
            newCtx.putImageData(imageData, 0, 0);
          }
          newCtx.drawImage ( maskImage, 0,0) ;
          newCtx.restore   () ;   

          // alert(JSON.stringify(this.cropper.getImageData()))
          console.log(this.cropper.getImageData())
          this.$store.commit('setPreviewImage', croppedImgCanvas.toDataURL('image/jpeg'))
          this.$router.push({ path: 'submit' })
        }

        maskImage.src = this.$store.state.maskImage;
        //   else
        //     maskImage.src = this.base_url+"Heart_Transparent_HotPink.png";
      },
      changeRotation(e){
        this.cropper.rotateTo(e.target.value)
      },
      changeZoom(e) {
        console.log(e.target.value)
        // this.cropper.scale(e.target.value / 100)
        this.cropper.zoomTo(e.target.value / 10)
      },
      getOrientation(file, callback) {
       var reader = new FileReader();
      reader.onload = function(event) {
        var view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xFFD8) return callback(-2);

        var length = view.byteLength,
            offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++)
              if (view.getUint16(offset + (i * 12), little) == 0x0112)
                return callback(view.getUint16(offset + (i * 12) + 8, little));
          }
          else if ((marker & 0xFF00) != 0xFF00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
    },
    prepareFile(files) {
      
        if(files.length == 0)
          return false
        if( 
            files[0].type.toString().indexOf('image') == -1 ||  
            ( 
              files[0].type.toString().indexOf('jpeg') == -1 && 
              files[0].type.toString().indexOf('bmp') == -1 && 
              files[0].type.toString().indexOf('gif') == -1 && 
              files[0].type.toString().indexOf('png') == -1 
            ) 
        ) { 
            this.errors = []
            this.errors.push('Invalid File Format.  Supports JPEG / PNG / GIF / BMP image format')
            return false 
        }
        console.log('upload new file') 
        this.loading = true
        this.getOrientation(files[0], (orientation)=>{
          let moveX= 0, moveY = 0, imageWidth, imageHeight
          let that = this 
          // this.uploadFile.newImage = true 
          var fReader = new FileReader(); 
          fReader.readAsDataURL(files[0]); 
          fReader.onloadend = (event)=>{ 
            let img = new Image(), that = this 
            img.src= event.target.result
            
            var maskImage = new Image();
            maskImage.onload = function (){
              var newCanvas = document.createElement('canvas'); 
              newCanvas.width  = maskImage.width ; 
              newCanvas.height = maskImage.height ; 
              var newCtx = newCanvas.getContext('2d') ; 
              newCtx.save      () ; 

              // rotate image based on orientation so it will always appears straight.
              //  orientation = 0
              switch(orientation) {
                case 6:
                  that.degree = 90
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageHeight > maskImage.width ? (imageHeight - ( (imageHeight - maskImage.width) /2)) : (maskImage.width - imageHeight) / 2 + imageHeight
                  moveY = imageWidth > maskImage.height ? ( -((imageWidth - maskImage.height ) / 2)) : ((maskImage.height - imageWidth) / 2 )
                  break;
                case 8:
                  that.degree = -90
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageHeight > maskImage.width ? (-( (imageHeight - maskImage.width) /2)) : (maskImage.width - imageHeight) / 2 
                  moveY = imageWidth > maskImage.height ? (imageWidth - ((imageWidth - maskImage.height ) / 2)) : ((maskImage.height - imageWidth) / 2 ) + imageWidth
                  break;

                  break;
                case 3:
                  that.degree = 180
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageWidth > maskImage.width ?  ( -((imageWidth - maskImage.Width ) / 2)) : ((maskImage.width - imageWidth ) / 2) + imageWidth
                  moveY = imageHeight > maskImage.height ? (imageHeight - ((imageHeight - maskImage.height ) / 2)) : ((maskImage.height /2 + imageHeight /2))
                  break;
                default:
                  that.degree = 0
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageWidth > maskImage.width ?  ( -((imageWidth - maskImage.Width ) / 2)) : ((maskImage.width /2 - imageWidth /2))
                  moveY = imageHeight > maskImage.height ? ( -((imageHeight - maskImage.height ) / 2)) : ((maskImage.height /2 - imageHeight /2))
              }

              newCtx.translate ( moveX, moveY) ; 
              newCtx.rotate  (that.degree*(Math.PI/180)); 
              newCtx.drawImage ( img, 0, 0, img.width, img.height, 0, 0, imageWidth, imageHeight) ;  
              newCtx.rotate  (-that.degree*(Math.PI/180)); 
              newCtx.translate ( -moveX, -moveY) ;
              // draw mask
              newCtx.drawImage ( maskImage, 0,0) ; 
              newCtx.restore   () ; 
              that.$store.commit('setSrcImage', img.src)
              that.$store.commit('setPreviewImage', newCanvas.toDataURL())
              that.loading = false
              that.cropper.destroy()
              that.$nextTick(()=>{
                that.initialize()
                console.log('done uploading')
                that.loading = false
              })
            }
            if(this.$store.state.noteType == 0)
              maskImage.src = process.env.BASE_URL+"Heart_Transparent_LightPink.png";
            else
              maskImage.src = process.env.BASE_URL+"Heart_Transparent_HotPink.png";
          }
        })
      }
    }
  }
</script>



<style lang="scss">
  div.cropper{
    position:relative;
    display:block;
    box-sizing:border-box;
    margin:0 auto;
    max-width:1107px;
    div.left:after{
      content: '';
      vertical-align: middle;
      display: inline-block;
      height: 100%;
      width: 0px;
    }
    div.left {
      height:450px;
      background-image: url(https://app.brighton.com/power-of-pink/viewport_background.gif)!important;
      display:inline-block;
      vertical-align:top;
      padding:20px;
      box-sizing:border-box;
      position:relative;
      vertical-align:top;
      width:40%;
      min-width:280px;
      border:1px solid #000;
      div.imageContainer{
        overflow:hidden;
        display:inline-block;
        vertical-align:middle;
        position:relative;
        width:270px;
        height:225px;
        margin: 0 auto;
        img#imageMask{
          position:absolute;
          top: 0;
          left:0;
          width:100%;
          height:100%;
          pointer-events: none;
        }
        .cropper-view-box{
          outline: none;
        }
        .cropper-modal{
          background:none;
          background-color:#dc568f;
          opacity:1;
        }
      }
      div.imageContainer.grayscale{
        .cropper-bg{
          filter: grayscale(1);
        }
      }
      img {
        max-width: 100%; /* This rule is very important, please do not ignore this! */
      }
    }
    div.middle{
      height:100%;
      display:inline-block;
      /* width:150px; */
      width:0px;
      vertical-align: top;
      margin: 0 20px;
      span.step:first-child{
        color: #000;
        background-color:#fff;
      }
      span.step{
        border:1px solid #000;
        background-color:#000;
        color:#fff;
        display:block;
        padding:20px;
        margin-bottom:10px;
        div{
          display:inline-block;
          vertical-align: middle;
        }
        span.num{
          box-sizing:border-box;
          font-size:40px;
          padding:0;
        }
        span{
          box-sizing:border-box;
          font-size:13px;
          display:block;
        }
      }
    }
    div.right{
      height:450px;
      border:1px solid #000;
      width:40%;
      min-width:425px;
      display:inline-block;
      vertical-align: top;
      text-align:center;
      padding:10px 0;
      box-sizing:border-box;
      .title{
        padding-top:30px;
        font-size:20px;
        line-height:1.8;
        font-weight:bold;
        width:100%;
        display:block;
        border-bottom:1px solid #000;
      }
      .controls{
        padding:10px;
        /* height:60%; */
        border:3px solid #000;
        margin-bottom:30px;
        box-sizing:border-box;
        .row{
          display:block;
          text-align:left;
          min-height:38px;
          position:relative;
          span{
            /* min-width:200px; */
            display:inline-block;
          }
          span.label{
            width:180px;
            vertical-align: middle;
            display:inline-block;
            font-weight:bold;
          }
        }
        input[type=file]{
          position:absolute;
          top:0;
          opacity:0;
          z-index:2;
          left:0;
          width:100%;
          height:100%;
        }
        input{
          width:calc(100% - 200px);
          display:inline-block;
          vertical-align: middle;
        }
      }
      .buttons{
        position:relative;
        box-sizing:border-box;
        padding:30px;
      }
      button{
        border:1px solid #000;
        color:#000;
        margin:5px;
        line-height:1.6em;
        background:none;
        font-weight:bold;
        padding:5px;
        cursor: pointer;
        transition: all 0.3s;
      }
      button:hover{
        color:white;
        background-color:#000;
      }
      button.save:hover{
        color:#000;
        background-color:#fff;
      }
      button.save{
        background:#000;
        width: 100px;
        color:#fff;
      }
      button.startOver{
        width:160px;
      }
      button.differentImg{
        width:270px;
        position:relative;
      }
      button.cancel{
        width:150px;
      }
    }
  }
  @media(max-width:796px){
    div.cropper div.left{
      padding:0;
      width:auto;
    }
  }
  @media(max-width:764px){
    div.cropper div.left{
      width:100%;
      border-bottom:none;
      display:block;
      height:auto;
      padding:20px 0;
    }
    div.cropper div.middle{
      display:none;
    }
    div.cropper div.right{
      display:block;
      border-top:none;
      width:100%;
      height:auto;
    }

  }
  @media(max-width:460px){
    div.cropper div.right{
      min-width:0;
      .controls{
        .row{
          padding:10px 0;
          text-align:center;
          span.label{
            width:auto;
            display:block;
          }
          input{
            width:100%;
          }
          border-bottom:1px solid #ccc;
        }
      }
      .buttons{
        padding:20px 0;
      }
    }
  }
  @media(max-width:350px){
    div.cropper div.right button.save,
    div.cropper div.right button.differentImg,
    div.cropper div.right button.startOver{
      width:100%;
      display: block;
      line-height:2em;
      margin-bottom:10px;
    }
  }












#trail{
    ul {
      list-style-type: none;
      padding: 0;
    }
    li {
      display: inline-block;
      margin: 0 10px;
    }
    a {
      color: #42b983;
    }
    clear: both;
    padding: 0 0 5px;
    margin: 0 auto 10px;
    border: none;
    overflow: hidden;
    ul{
      text-align:left;
      li{
        /* display: inline; */
        padding: 0 4px 0 10px;
        margin: 0 4px 0 0;
            padding-left: 1.25em;
            background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA3NiA2Ny40Jz48ZGVmcz48c3R5bGU+LmF7ZmlsbDojOTE5MTkxO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aGVhcnQ8L3RpdGxlPjxwYXRoIGNsYXNzPSdhJyBkPSdNNzYsMTkuOGEyOC40NSwyOC40NSwwLDAsMS0yLDkuN0M2OC4zLDQzLjcsMzcuOCw2Ny40LDM3LjgsNjcuNFM4LDQ0LjUsMi4xLDI5LjRBMzAuNDksMzAuNDksMCwwLDEsMCwxOS44YTE5Ljc4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+) 0 center no-repeat;;
            background-position: 0 .25em;
            background-size: 1em;
      }
    }
    a{
      color: #000;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: .08em;
      text-transform: uppercase;
    }
  }
  .staticPopTextWrapper{
    min-width: 300px;
    width: 84%;
    display: block;
    margin: 20px auto;
    text-align: center;
    .popButterflyTopSmallText{
      display: inline-block;
      position: relative;
      font-size: 87px;
      font-family: "Times New Roman", Times, serif;
      color: #F43A83;
      vertical-align: top;
      margin: 5px 2px 0;
      font-style: italic;
      line-height: 80px;
    }
    .popButterflyTopLargeText{
      display: inline-block;
      position: relative;
      font-size: 87px;
      font-family: 'Lato', sans-serif;
      color: #EE3E86;
      vertical-align: top;
      margin: 5px 2px 0;
      font-weight: bold;
      line-height: 80px;
    }
    .popButterflyTopYears{
      font: italic 30px/36px "Times New Roman", Times, serif;
      color: #000;
      display: block;
      margin: 10px 0 50px 0;
      font-weight: 600;
    }
    .popButterflyTopRecognition{
      display: block;
      position: relative;
      font: 900 16px/24px 'Lato', Arial, Helvetica, sans-serif;
      color: #000000;
      text-transform: uppercase;
      letter-spacing: 2px;
      margin: 0 auto;
      width:60%
    }
  }
  @media(max-width:768px) {
    .staticPopTextWrapper {
      /* margin:0 auto; */
      width:auto;
      .popButterflyTopRecognition{
          width:80%;
      }
      .popButterflyTopYears{
        margin-bottom:10px;
      }
    }
  }
  @media(max-width:550px) {
    .staticPopTextWrapper {
    
      .popButterflyTopLargeText,
      .popButterflyTopSmallText {
        font-size:15vw;
        line-height:15vw;
      }
    }
  }
</style>